import bugsnag from '../config/bugsnag'
export default function reportError({ error }) {
  console.log('[reportError]', error)
  bugsnag.notify(JSON.stringify(error))
}
